import { MMKV } from "react-native-mmkv";

// MMKV configuration
export const mmkv = new MMKV();
